import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import { ApolloProvider } from '@apollo/client';
import client from './graphql-client';
import { AuthProvider } from 'contexts/auth';
import { NotificationsProvider } from '@mantine/notifications';
import { MantineProvider } from '@mantine/core';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle, theme } from '@teamfabric/copilot-ui';

ReactDOM.render(
  <React.StrictMode>
    <MantineProvider>
      <ThemeProvider theme={{ theme }}>
        {/* <GlobalStyle /> */}
        <NotificationsProvider>
          <ApolloProvider client={client}>
            <AuthProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </AuthProvider>
          </ApolloProvider>
        </NotificationsProvider>
      </ThemeProvider>
    </MantineProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
